


































































































































































import {Vue, Component, Provide, Watch} from 'vue-property-decorator';
import Drift from 'drift-zoom';
import {mapActions, mapGetters} from 'vuex';
import {API} from '@/services/api/api';
import {getImage, Utils} from '@/utils/Utils';
import ShipList from '@/models/shiplist';
import Constants from '@/utils/constants';
import {findDeckMarkerInDeckImg} from '@/utils/DeckOperations';
import Cropper from 'cropperjs';
import canvasMerge from '@/utils/CanvasMerge';
import 'cropperjs/dist/cropper.css';
import {debounce} from 'ts-debounce';
@Component({
  computed: {...mapGetters(['shipList'])},

  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
})
export default class CreateCenterPoint extends Vue {
  // form variables
  shipId: number = null;
  shipList: ShipList[];
  isScreenLoading = true;
  deckName = '';
  centerFrom: number = null;
  frameEnd: number = null;
  centerUpto: number = null;
  btnLoader = false;
  deckId: number = null;
  decks: any = [];
  deckImageURL = '';
  createdImage = null;
  customeImageGet = false;
  scandResult = null;
  deckList = [];
  selectedShip: number = null;
  showSuccessToast: any;
  showErrorToast: any;

  //validation variables
  shipValidationMsg = '';
  deckValidationMsg = '';
  centerFromValidationMsg = '';
  centerUptoValidationMsg = '';
  commonValidationMsg = 'This field is required';
  lengthValidationMsg = 'Can not be more than 7 digits';

  //other varibales
  cropper = null;
  _findCenterPointscropper = null;
  isAutomatedEnable = true;
  imgBase64URL: '';
  summary: any;
  drift = null;

  // clear fields
  clearDeckAndImage() {
    this.deckName = '';
    this.deckImageURL = '';
    this.createdImage = null;
    this.centerUpto = null;
    this.centerFrom = null;
    this.centerFromValidationMsg = '';
    this.centerUptoValidationMsg = '';
  }

  // change ship handler
  async changeShip() {
    this.validateShipSelect();
    this.clearDeckAndImage();
    if (this.selectedShip !== null || this.selectedShip.toString().length > 0) {
      this.shipValidationMsg = '';
      try {
        this.isScreenLoading = true;
        const params = {
          alldecks: 0,
          withoutzones: 0,
          withoutcenter: 1,
        };
        const response = await API.fetchEmptyDecksByShipId(params, this.selectedShip);

        if (response.data) {
          const data = response.data;

          if (data.drawings === [] || data.drawings.length < 1) this.showErrorToast({msg: 'deck not found'});
          this.deckList = data.drawings;
        } else {
          this.showErrorToast({
            msg: response.error,
          });
        }
      } catch (error) {
        this.showErrorToast({msg: error});
      } finally {
        this.isScreenLoading = false;
      }
    }
  }

  // change handler deck
  changeDeck() {
    this.centerFromValidationMsg = '';
    this.centerUptoValidationMsg = '';
    this.validateShipSelect();
    this.validateDeckSelect();
    this.showDeckImage();
  }

  //validate ship select
  validateShipSelect() {
    if (this.selectedShip === null || this.selectedShip.toString().length < 1) {
      this.shipValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.shipValidationMsg = '';
      return true;
    }
  }

  //validate deck select
  validateDeckSelect() {
    if (this.deckName === null || this.deckName.length < 1) {
      this.deckValidationMsg = this.commonValidationMsg;
      return false;
    } else {
      this.deckValidationMsg = '';

      return true;
    }
  }

  //validate center from
  validatecenterFrom() {
    if (this.centerFrom === null || this.centerFrom.toString().length < 1) {
      this.centerFromValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.centerFrom.toString().length > 7) {
      this.centerFromValidationMsg = this.lengthValidationMsg;
      return false;
    } else {
      this.centerFromValidationMsg = '';
      return true;
    }
  }

  //validate center upto
  validatecenterUpto() {
    if (this.centerUpto === null || this.centerUpto.toString().length < 1) {
      this.centerUptoValidationMsg = this.commonValidationMsg;
      return false;
    } else if (this.centerUpto.toString().length > 7) {
      this.centerFromValidationMsg = this.lengthValidationMsg;
      return false;
    } else {
      this.centerUptoValidationMsg = '';
      return true;
    }
  }

  //validate all
  validateAll() {
    return (
      this.validateShipSelect() && this.validateDeckSelect() && this.validatecenterFrom() && this.validatecenterUpto()
    );
  }

  //create handler
  async _createHandler() {
    if (!this.validateAll()) return true;

    try {
      this.btnLoader = true;
      const formInput = {
        DeckId: this.deckName,
        CenterFrom: this.centerFrom,
        CenterUpto: this.centerUpto,
      };
      const response = await API.createCenterPoint(formInput);
      if (response.data) {
        this.showSuccessToast({msg: response.message});
        this.goToList();
      } else {
        this.showErrorToast({msg: 'Network Error'});
      }
    } catch (error) {
      console.error(error);

      this.showErrorToast({msg: 'Network Error'});
    } finally {
      this.btnLoader = false;
    }
  }

  //clearing form
  _clearHandler() {
    this._clearForm();
  }

  //navigate to list page
  goToList() {
    document.body.removeEventListener('keydown', this.keyDownEvent);
    this.$router.go(-1);
  }

  //clear form fields
  _clearForm() {
    this.selectedShip = null;
    this.deckName = '';
    this.centerFrom = null;
    this.centerUpto = null;
    this.centerUptoValidationMsg = '';
    this.centerFromValidationMsg = '';
    this.deckValidationMsg = '';
    this.shipValidationMsg = '';
  }

  //initialize zoomed container on hover image
  initDriftZoom() {
    document.querySelectorAll('.drift-bounding-box').forEach((element) => {
      element.remove();
    });
    this.drift = new Drift(this.$refs.image2, {
      paneContainer: document.getElementById('ppppp'),
      inlineOffsetY: -85,
      containInline: true,
      handleTouch: false,
      inlinePane: false,
      zoomFactor: 5,
      hoverBoundingBox: true,
    });
  }

  //disbale/destroy zoom
  disableDriftZoom() {
    if (this.drift) {
      this.drift.destroy();
    }
  }

  mounted() {
    document.body.addEventListener('keydown', this.keyDownEvent);
  }

  keyDownEvent(event) {
    let e = event || window.event;
    Utils.keyDownEvent(e, this.cropper);
  }

  //on deck load
  onDeckLoad() {
    this.initCropper();
    this.draw();
  }

  // on load second image container
  onDeckLoad2() {
    this.initDriftZoom();
  }

  // initialize image cropper on image
  initCropper() {
    const t = this.$refs.image as HTMLImageElement;
    const _this = this;
    this.cropper = new Cropper(t, {
      crop() {
        const data = this.cropper.getData(true);
        _this.centerFrom = data.y;
        _this.centerUpto = data.y + data.height;
      },
      zoomable: false,
      viewMode: 2,
      data: {
        x: t.naturalWidth / 3,
        y: t.naturalHeight / 3,
        width: t.naturalWidth / 3,
        height: t.naturalHeight / 3,
      },
    });
  }

  // re-initialized cropper on image
  distroyCropper() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  //load image , then download image from server as blob then convert it into base64 to draw image on canvas
  async showDeckImage() {
    if (this.selectedShip !== null && this.shipList.length > 0 && this.deckList.length > 0 && this.deckName != '') {
      const index = this.deckList.findIndex((obj: any) => obj.drawingId == this.deckName);
      if (index != -1) {
        try {
          this.createdImage = null;
          this.isScreenLoading = true;
          this.scandResult = Utils.parseJson(this.deckList[index].scanResult);
          this.deckImageURL = await getImage(this.deckList[index].imagePath);
          this.createdImage = null;
          this.centerFrom = null;
          this.centerUpto = null;
        } catch (error) {
          this.showErrorToast({msg: 'Network Error'});
        } finally {
          this.isScreenLoading = false;
        }
      }
    }
  }

  @Watch('shipList', {immediate: true})
  loadDeckList() {
    this.isScreenLoading = false;
  }

  //find center point and place the value in respetive field
  _findCenters() {
    if (this.scandResult != null) {
      const Center = this.scandResult.Center;

      let centerFrom = Center.EndPoint.Y;
      let centerUpto = Center.StartPoint.Y;
      if (centerFrom === 0 && centerUpto === 0) {
        this.showErrorToast({msg: 'No center point found'});
        return;
      } else if (centerFrom > centerUpto) {
        let temp = centerFrom;
        centerFrom = centerUpto;
        centerUpto = temp;
      }

      this.centerFrom = parseInt(centerFrom);
      this.centerUpto = parseInt(centerUpto);
      if (this.cropper) {
        const t = this.$refs.image as HTMLImageElement;
        let data = {
          x: 0,
          y: this.centerFrom,
          width: t.naturalWidth,
          height: this.centerUpto - this.centerFrom,
        };
        this.cropper.setData(data);
      }
    } else {
      this.showErrorToast({msg: 'Center not found'});
    }
  }

  //cropper got re-initialized
  _reseImage() {
    if (this.cropper) {
      this.cropper.reset();
    }
  }

  _getImage() {
    this.drawRect();
  }

  //draw center point on image
  drawRect() {
    if (this.cropper && this.centerFrom && this.centerUpto && this.centerFrom != 0 && this.centerUpto != 0) {
      const data = this.cropper.getData(true);
      const t = this.$refs.image as HTMLImageElement;
      this.mergeImage({
        x: 0,
        y: this.centerFrom,
        width: t.naturalWidth,
        height: this.centerUpto - this.centerFrom,
      });
    }
  }

  draw = debounce(() => this.drawRect(), 500);

  @Watch('centerFrom')
  changedCenterFrom() {
    this.draw();
  }

  @Watch('centerUpto')
  changedCenterUpto() {
    this.draw();
  }

  // draw line on center point original image
  mergeImage(path) {
    this.customeImageGet = true;
    const _this = this;
    canvasMerge(this.deckImageURL, path, {drawType: 'rect'})
      .then((b64) => {
        _this.createdImage = b64;
        _this.customeImageGet = false;
      })
      .catch((e) => {
        _this.customeImageGet = false;
      });
  }
}
